const INTERVAL = 4000;
const RESUME_AFTER = 8000;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function hasProducts(carousel) {
  return Boolean(carousel.querySelector(':scope > product-card'));
}

function lastStartIndex(carousel) {
  const cells = carousel.cells;
  const cellWidth = cells[0]?.getBoundingClientRect().width || 1;
  const visible = Math.max(1, Math.round(carousel.clientWidth / cellWidth));
  return Math.max(0, cells.length - visible);
}

function isAtEnd(carousel) {
  return Math.abs(carousel.scrollLeft) >= carousel.scrollWidth - carousel.clientWidth - 2;
}

function setup(carousel) {
  if (carousel.dataset.slovanAutoplay) return;
  if (!hasProducts(carousel) || carousel.cells.length < 2) return;
  carousel.dataset.slovanAutoplay = 'true';

  const start = Math.floor(Math.random() * (lastStartIndex(carousel) + 1));
  if (start > 0) carousel.select(start, { instant: true });

  if (reduceMotion.matches) return;

  let inView = false;
  let hovered = false;
  let pausedUntil = 0;
  const hold = () => {
    pausedUntil = Date.now() + RESUME_AFTER;
  };

  new IntersectionObserver(([entry]) => {
    inView = entry.isIntersecting;
  }, { threshold: 0.3 }).observe(carousel);

  carousel.addEventListener('pointerenter', (event) => {
    if (event.pointerType === 'mouse') hovered = true;
  });
  carousel.addEventListener('pointerleave', (event) => {
    if (event.pointerType === 'mouse') hovered = false;
  });
  ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach((type) => {
    carousel.addEventListener(type, hold, { passive: true });
  });
  if (carousel.id) {
    document.querySelectorAll(`[aria-controls="${carousel.id}"]`).forEach((control) => {
      control.addEventListener('click', hold);
    });
  }

  setInterval(() => {
    if (!inView || hovered || document.hidden || Date.now() < pausedUntil) return;
    if (!carousel.isScrollable || carousel.offsetParent === null) return;

    if (isAtEnd(carousel)) {
      carousel.select(0);
    } else {
      carousel.select(Math.min(carousel.selectedIndex + 1, carousel.cells.length - 1));
    }
  }, INTERVAL);
}

function scan(root = document) {
  root.querySelectorAll('scroll-carousel.product-list--carousel').forEach((carousel) => {
    requestAnimationFrame(() => setup(carousel));
  });
}

customElements.whenDefined('scroll-carousel').then(() => {
  scan();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) scan(node.matches?.('scroll-carousel') ? node.parentElement : node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
});
